
import { toggleSlide } from './Util';

const initNotifications = function() {
	document.addEventListener( 'click', ( ev ) => {
		if ( ev.target && ev.target.closest( '.notification_close' ) ) {
			const notificationEl = ev.target.closest( '.notification' );
			toggleSlide( notificationEl, false );
		}
	} );
};

export {initNotifications};
